import { cn } from '../../lib/cn';

export default function StimulusSuggestionBanner({ suggestions, onLink, onDismiss, className }) {
  if (!suggestions || suggestions.length === 0) return null;

  const top = suggestions[0];

  return (
    <div
      className={cn(
        'flex items-start gap-3 px-4 py-3 rounded-lg',
        'bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700',
        className
      )}
    >
      <svg className="w-4 h-4 text-gray-400 dark:text-gray-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          May relate to{' '}
          <span className="font-medium text-gray-700 dark:text-gray-300">
            {top.chapter_title}
          </span>
          {top.library_item_title && (
            <span> from {top.library_item_title}</span>
          )}
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5 truncate">
          {top.preview}
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={() => onLink(top)}
          className="text-xs font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          Link
        </button>
        <button
          onClick={onDismiss}
          className="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
